import type { ReactNode } from 'react';

/**
 * Inline link-styled button for table cells (bucket names, folder rows). Keeps
 * the accent-text treatment consistent across the Object Storage list pages
 * without a per-page CSS module.
 */
export function LinkButton({
  onClick,
  children,
}: {
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={{
        color: 'var(--vn-accent-text, var(--vn-accent-solid))',
        fontWeight: 'var(--vn-font-weight-medium)',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        textAlign: 'left',
        font: 'inherit',
        overflowWrap: 'anywhere',
        minWidth: 0,
      }}
    >
      {children}
    </button>
  );
}

/** Monospaced inline span for keys, etags and sizes. */
export function Mono({ children }: { children: ReactNode }) {
  return <span style={{ fontFamily: 'var(--vn-font-mono)', overflowWrap: 'anywhere' }}>{children}</span>;
}
